import * as React from "react";
import { withTracking } from "react-tracker";
import { Spinner } from "reactstrap";
import { useLocation } from "react-router-dom";
import { FaChevronCircleLeft } from "react-icons/fa";

import { useSections, useUser, useResources } from "../../helpers/satiBack";
import { interaction } from "./events";
import Card from "./components/Card";
import useHealthWeekMetrics from "./hooks/useHealthWeekMetrics";
import usePageTracking from "../../hooks/usePageTracking";

import "./styles/healthweek.scss";

function ContentSubsection({ subsection }) {
  const { data: resourcesResponse, isLoading: isLoadingResources } = useResources({
    subsectionId: subsection.id,
  });

  const { isLoading: isLoadingUser, data: user } = useUser();

  const healthWeekStartDate = sessionStorage.getItem("healthWeekStartDate");
  
  const { groupedResources: resources } = useHealthWeekMetrics(
    healthWeekStartDate,
    resourcesResponse?.data
  );

  if (isLoadingResources || isLoadingUser)
    return (
      <div className="health-week-container">
        <Spinner className="loading-spinner" />
      </div>
    );

  const nombre = user?.data?.nombre || "";

  return (
    <React.Fragment>
      <div className="heading">
        <span>Bienvenido, {nombre.split(" ")[0]}</span>
        <span>{subsection.description}</span>
      </div>

      <div className="section-buttons">
        {resources.map((resource) => (
          <a
            href={`#week-${resource.week}`}
            key={`go-to-week-${resource.week}`}
          >
            Semana {resource.week}
          </a>
        ))}
      </div>

      <div className="content">
        {resources.map((resource) => (
          <div
            className="section"
            id={`week-${resource.week}`}
            key={`week-${resource.week}`}
          >
            <span className="section-title">Semana {resource.week}</span>
            <div className="subsections">
              {resource.resources?.map((resource) => (
                <Card key={resource.title} {...resource} />
              ))}

              {resource.resources.length < 1 && (
                <span>No hay contenido aún para mostrar...</span>
              )}
            </div>

            <hr />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

function HealthWeek({ trackInteraction }) {
  const { isLoading: isLoadingResources, data: sections } = useSections();
  const { isLoading: isLoadingUser, data: user } = useUser();
  const { pathname } = useLocation();
  const PAGE_NAME = pathname.split("/")[1].toUpperCase() || "N/A";

  const { handleInteraction } = usePageTracking({
    pageName: PAGE_NAME,
    trackInteraction
  });

  const [selectedSubsection, setSelectedSubsection] = React.useState(null);

  const onBackClick = (event) => {
    handleInteraction(event.currentTarget.dataset?.element);
    setSelectedSubsection(null);
  };

  if (isLoadingResources || isLoadingUser)
    return (
      <div className="health-week-container">
        <Spinner className="loading-spinner" />
      </div>
    );

  const nombreMain = user?.data?.nombre || "";

  if (selectedSubsection) {
    return (
      <div className="health-week-container">
        <div
          className="go-back-button-container"
          data-element="go-back-to-sections-button"
          onClick={onBackClick}
        >
          <FaChevronCircleLeft className="go-back-to-sections" />
          <span>Ir atrás</span>
        </div>

        <ContentSubsection subsection={selectedSubsection} />
      </div>
    );
  }

  return (
    <div className="health-week-container">
      <div className="heading">
        <span>Bienvenido, {nombreMain.split(" ")[0]}</span>
        <span>
          Charlas informativas para cuidar tu salud y tutoriales de nuestros
          servicios para que puedas aprovecharlos al máximo.
        </span>
      </div>

      <div className="section-buttons">
        {sections.data?.map((section) => (
          <a
            href={`#section-${section.title.replace(" ", "-")}`}
            key={`go-to-${section.title.replace(" ", "-")}`}
          >
            {section.title}
          </a>
        ))}
      </div>

      <div className="content">
        {sections.data?.map((section) => (
          <div
            className="section"
            id={`section-${section.title.replace(" ", "-")}`}
            key={section.id}
          >
            <span className="section-title">{section.title}</span>
            <div className="subsections">
              {section.subsections.map((subsection) => (
                <Card
                  key={subsection.title}
                  contentType="SUBSECTION"
                  onClick={() => setSelectedSubsection(subsection)}
                  {...subsection}
                />
              ))}
            </div>

            <hr />
          </div>
        ))}
      </div>
    </div>
  );
}

const mapTrackingToProps = (trackEvent) => ({
  trackInteraction: (data) => trackEvent(interaction(data)),
});

const HealthWeekWithTracking = withTracking(mapTrackingToProps)(HealthWeek);

export default HealthWeekWithTracking;
